import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TerminologyService } from '../../services/terminology.service';
import { BrowserUtilityService } from '../../services/browser-utility.service';
@Component({
  standalone: false,
  selector: 'app-hierarchy-chunk',
  templateUrl: './hierarchy-chunk.component.html',
  styleUrls: ['./hierarchy-chunk.component.css'],
})
export class HierarchyChunkComponent implements OnInit, OnChanges {
  @Input() currentProject: any;
  @Input() currentOrgUriLabel: string;
  @Input() selectedConcept: any;
  @Input() isInverse = false;
  @Input() terminologies = [];
  @Output() onClick = new EventEmitter<any>();

  activeTreePosition: any;
  treeData = [];
  totalTreePositions = 0;
  showChunk = true;
  treeOffset = 0;
  sortField = 'concept';
  ascending = true;
  treePositionsList = [];
  isLoading = false;
  finalIndex: any;
  perPage = 10;
  page = 1;
  perPageValue: any;
  selectedOption: any;
  label = 'Hierarchy';
  isCollapsed = false;
  isModalOpen: boolean;

  constructor(
    private readonly terminologyService: TerminologyService,
    readonly browserUtility: BrowserUtilityService,
  ) {}

  ngOnInit() {
    this.finalIndex = this.perPageValue = 10;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedConcept?.currentValue) {
      this.ascending = true;
      this.resetValues();
    }
  }

  resetValues() {
    this.isLoading = true;
    this.page = 1;
    this.onPageChange(1);
    this.treePositionsList = [];
    this.activeTreePosition = null;
    this.totalTreePositions = 0;
  }

  onChange(data) {}

  getTreeData(): void {
    this.isLoading = false;
    if (this.selectedConcept !== null) {
      if (this.selectedConcept?.id != null && this.selectedConcept?.active) {
        this.isLoading = true;
        this.terminologyService
          .getConceptTreePositions(this.currentProject?.id, this.selectedConcept?.id, this.perPage, this.treeOffset, 'ancestorPath', this.ascending)
          .subscribe((data) => {
            this.totalTreePositions = data?.total;
            this.treePositionsList = [];
            data?.items?.forEach((item: any) => {
              const conceptPositionList: any[] = [];
              this.findConceptNameByCode(item, conceptPositionList);
              this.treePositionsList.push([item, conceptPositionList.reverse()]);
            });

            setTimeout(() => {
              if (this.treePositionsList?.length === 0 && this.treePositionsList[0]?.length === 0) {
                this.showChunk = false;
              }
              if (this.treePositionsList.length > 0 && this.treePositionsList[0].length > 0) {
                this.setActiveTreePosition(0);
              } else {
                if (this.treePositionsList.length === 0) {
                  this.isCollapsed = true;
                }
              }
              this.label = this.browserUtility.getBrowserUiLabel(
                this.selectedConcept?.publisher,
                this.selectedConcept?.terminology,
                this.selectedConcept?.version,
                'treePosition',
                'Hierarchy',
              );

              this.isLoading = false;
            }, 150);
          });
      }
    }
  }

  findConceptNameByCode(item: any, conceptPositionList: string[]): boolean {
    const currentConceptMatches = item?.concept?.code === this.selectedConcept?.code;

    let childMatchFound = false;
    if (item?.children) {
      for (const child of item.children) {
        if (this.findConceptNameByCode(child, conceptPositionList)) {
          childMatchFound = true;
        }
      }
    }

    if (currentConceptMatches || childMatchFound) {
      conceptPositionList.push(item?.concept);
    }

    return currentConceptMatches || childMatchFound;
  }

  setActiveTreePosition(index: number) {
    this.activeTreePosition = this.treePositionsList[index][0];
    this.treeData = JSON.parse(JSON.stringify(this.treePositionsList[index][0]));
  }

  goToConcept(concept: any) {
    concept.terminology = this.selectedConcept.terminology;
    concept.publisher = this.selectedConcept.publisher;
    this.onClick.emit(concept);
  }

  resetTreePositionsList() {
    this.treePositionsList = [];
    for (let i = 0; i < this.perPage; i++) {
      this.treePositionsList[i] = [{}, [{ name: 'Loading...' }]];
    }
  }

  selectPaginationLimit(event: any) {
    this.perPage = event;
    if (event === '') {
      this.perPageValue = 'All';
      this.perPage = this.finalIndex = 100000;
    } else {
      this.finalIndex = this.perPageValue = event;
    }
    this.onPageChange(1);
  }

  onPageChange(page: any) {
    this.resetTreePositionsList();
    this.page = page;
    this.treeOffset = (this.page - 1) * this.perPage;
    this.getTreeData();
  }

  sort(field: string) {
    if (this.sortField === field) {
      this.ascending = !this.ascending;
    } else {
      this.ascending = false;
    }
    this.sortField = field;

    this.getTreeData();
  }

  openModal() {
    this.isModalOpen = true;
  }

  handleModalClosed() {
    this.isModalOpen = false;
  }
}
